const othersData = [
    {
        category: 'others',
        id: '1',
        alt: '',
        title: '',
        blurhash: 'LOA0E%xZ9vNJ}?xYENNK=_s.I;WX',
        orientation: 'landscape'
    },
    {
        category: 'others',
        id: '7',
        alt: '',
        title: '',
        blurhash: 'L56%.*Wp02Ip9vf6={s:0MoL~Bxa',
        orientation: 'landscape'
    },
    {
        category: 'others',
        id: '6',
        alt: '',
        title: '',
        blurhash: 'L271u=E7N2_H01RixrIc.Qbrf$og',
        orientation: 'landscape'
    },
    {
        category: 'others',
        id: '2',
        alt: '',
        title: '',
        blurhash: 'U48Nt9E408?W8zS4M}NH06xr~j9JD-s.?XkB',
        orientation: 'landscape'
    },
    {
        category: 'others',
        id: '3',
        alt: '',
        title: '',
        blurhash: 'L7A15?x=WCnm_JtQoeMz02xuRRIp',
        orientation: 'landscape'
    },
    {
        category: 'others',
        id: '4',
        alt: '',
        title: '',
        blurhash: 'LzI}|vofjsj[~qa#ayj[-:WBj]j[',
        orientation: 'landscape'
    },
    {
        category: 'others',
        id: '5',
        alt: '',
        title: '',
        blurhash: 'L$Jk+Vt7s,j[~qofj[j[-:WBa~oL',
        orientation: 'landscape'
    }
];

export default othersData;
